import { render, staticRenderFns } from "./InvitationsModal.vue?vue&type=template&id=378b2736&"
import script from "./InvitationsModal.vue?vue&type=script&lang=js&"
export * from "./InvitationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports